import React from 'react'
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import './SocialFollow.css'
import { Typography } from '@material-ui/core';

function SocialFollow() {
    return (
        <>
            <Typography>
                <div className="social-container"> 
                    <p className="social__text"> Stay in touch with us</p>
                    <a href="https://www.facebook.com/aatransportersltd/" className="facebook social">
                        <FacebookIcon fontSize="large" />
                    </a>
                    <a href="https://www.instagram.com/aatransportersltd/" className="instagram social">
                        <InstagramIcon fontSize="large" />
                    </a>
                    <a 
                        href="https://wa.me/254735886887" 
                        className="whatsapp social"
                        target="_blank"
                        rel="noopener noreferrer">
                        <WhatsAppIcon fontSize="large" />
                    </a>
                </div>
            </Typography>
        </>
        
    )
}

export default SocialFollow
